/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TicketSubsidyLogDto } from '../../models/ticket-subsidy-log-dto';

export interface TicketSubsidyControllerFindLogById$Params {
  id: string;
}

export function ticketSubsidyControllerFindLogById(http: HttpClient, rootUrl: string, params: TicketSubsidyControllerFindLogById$Params, context?: HttpContext): Observable<StrictHttpResponse<TicketSubsidyLogDto>> {
  const rb = new RequestBuilder(rootUrl, ticketSubsidyControllerFindLogById.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TicketSubsidyLogDto>;
    })
  );
}

ticketSubsidyControllerFindLogById.PATH = '/api/ticket-subsidy/{id}';
